import React, { useState, useContext, useEffect, useRef } from "react";
import axios from "axios";
import { Card, Avatar, Input, Image, Modal, Button, Menu, Col, Row, message, Space, Pagination, Tab, ConfigProvider } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { EditOutlined, DeleteOutlined, UserOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import Label_language from '../language';
import FileFolderCard from "./components/Media/FileFloderCard";
import MediaCard from "./components/Media/MediaCard";
import AdminFolderModal from "./components/AdminFolderModal";
import AdminFileModal from "./components/Media/AdminFileModal";
import SearchModal from "../search/SearchModal";
import Carousel_news_ticker from "./components/Carousel_news_ticker";
import PreviewImgModal from "./components/Media/PreviewImgModal";
const { Search } = Input;
const label_language = Label_language.cramschool.children
const AdminMedia = ({
    blog_type_name = ''
}) => {
    const category = [
        // {
        //   "category_id":1,
        //   "category_name":"為你推薦",
        //   "background_color":"#c78063"
        // },
        // {
        //   "category_id":2,
        //   "category_name":"最近瀏覽",
        //   "background_color":"#9596CC"
        // },
        {
            "category_id": 1,
            "category_name": "總覽",
            "background_color": "#627bc6"
        }
    ];
    const [modal_img, set_modal_img] = useState(false);
    const [img, setImg] = useState('');
    const language = useContext(ConfigProvider.ConfigContext).locale.locale;
    const [messageApi, contextHolder] = message.useMessage();
    const [maintitle, setMainTitle] = useState('最新消息公告');
    const [edit, setEdit] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [title, setTitle] = useState('新增');
    const [editcard, setEditCard] = useState({});
    const [file_open, set_file_open] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [data, setData] = useState([]);
    const [click_button, set_click_button] = useState('全部');
    const [filter_data, set_filter_data] = useState([{
        type: 'text',
        label: '簡易查詢',
        name: 'custom_filter_value'
    }, {
        type: 'rangepicker',
        label: '日期搜尋',
        name: 'date'
    }, {
        type: 'checkbox-group',
        label: '進階搜尋',
        name: 'custom_filter_key',
        options: [
            {
                label: '上傳人',
                value: 'upload_user_name',
                id: 1
            },
            {
                label: '檔案名稱',
                value: 'file_client_name',
                id: 2
            },
            {
                label: '編輯人',
                value: 'last_edit_user_name',
                id: 3
            },
        ]
    }])
    const [buuton_item, set_button_item] = useState(['全部', '最新', '最多點擊', '最多下載', '出遊日記', '考試檢定',])
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [color1, setColor1] = useState('black')
    const get_data = () => {
        axios
            .get('/cramSchool/api/media/' + blog_type_name)
            .then((response) => {
                setData(response.data.data);
                get_picture(response.data.data);
                // setData(default_Data);
                // set_data_tmp(default_Data.slice(0, 2));
                // get_picture(default_Data);
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let file_id = value['file_id']
            if (value.file_id) {
                [value.file_id].map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setData(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (file_id == value.file_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const handleOnEdit = () => {
        setTitle('編輯');
        setEdit(true);
        setAddOpen(true);
    }
    useEffect(() => {
        setData([])
        get_data();
    }, [blog_type_name])
    const onSubmit = (value) => {
        let value_tmp = value;
        if (value_tmp?.date && value_tmp?.date?.length != 0) {
            value_tmp['upload_time_start'] = value.date[0];
            value_tmp['upload_time_end'] = value.date[1];
        } else {
            delete value_tmp['date']
        }
        console.log(value_tmp);
        axios
            .get('/cramSchool/api/media/' + blog_type_name, {
                params: { ...value_tmp, "blog_type_id": 1 }
            })
            .then((response) => {
                setData(response.data.data);
                get_picture(response.data.data);
                // setData(default_Data);
                // set_data_tmp(default_Data.slice(0, 2));
                // get_picture(default_Data);
            })
    }
    const handleEdit = (item) => {
        console.log(item);
        setEditCard(item);
        setColor('f09a45');
        set_file_open(true);
    }
    const handleEditFile = (file_name) => {
        console.log(file_name);
        axios
            .patch('/cramSchool/api/media/' + blog_type_name, [{ ...editcard, file_client_name: file_name }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    set_file_open(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                    get_data();
                } else {
                    set_file_open(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                    get_data();
                }
            })
    }
    const handleDelete = (id) => {
        const deleterow = [{ "file_id": [id] }];
        axios
            .delete('/cramSchool/api/media/' + blog_type_name, {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    set_file_open(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.delete_error[language],
                    });
                    get_data();
                } else {
                    set_file_open(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.delete_success[language],
                    });
                    get_data();
                }
            })
    }
    const handlePreview = (url) => {
        setImg(url);
        set_modal_img(true);
    }
    const openDelete = () => {

    }
    // useEffect(() => {
    //     var str = 'a12.docx';
    //     // var str = 'a.12.doc';
    //     let [firstName, lastName] = str.split('.');
    //     console.log(firstName);
    //     console.log(lastName);
    // })
    return (
        <>
            {contextHolder}
            <PreviewImgModal
                modal_img={modal_img}
                set_modal_img={set_modal_img}
                img={img}
            ></PreviewImgModal>
            <AdminFolderModal
                open={addOpen}
                setOpen={setAddOpen}
                title={title}
                color={color}
                edit={edit}
                tag={false}
            />
            <AdminFileModal
                open={file_open}
                setOpen={set_file_open}
                color={color}
                edit={true}
                editcard={editcard}
                setEditCard={setEditCard}
                handleEdit={handleEditFile}
                handleDelete={handleDelete}
                delete={true}
                tag={false}
            />
            <Row gutter={[8, 24]} justify={'end'}>
                <Col span={24}>
                    <SearchModal data={filter_data} row_size={2} BodyColor={'white'} SubmitTitle={'查詢'} onSubmit={onSubmit}></SearchModal>
                </Col>
                <Col span={24} hidden>
                    <Row align={'middle'} gutter={24}>
                        <Col style={{ fontWeight: 600, color: '#e33d98' }}>簡易搜尋</Col>
                        <Col span={20}>
                            <Search
                                placeholder="請輸入關鍵字"
                                // onSearch={onSearch}
                                style={{
                                    width: '100%',
                                }}
                            /></Col>
                    </Row>
                </Col>
                <Col span={24} hidden>
                    <Row align={'middle'} gutter={24}>
                        <Col style={{ fontWeight: 600, color: '#e33d98' }}>進階搜尋{open ? <UpOutlined onClick={e => setOpen(false)} /> : <DownOutlined onClick={e => setOpen(true)} />}</Col>
                        <Col span={20}>
                        </Col>
                    </Row>
                </Col>
                {/* <Col span={24}>
                    <Row gutter={[16, 8]}>
                        {buuton_item && buuton_item.map((item, i) => {
                            if (click_button == item) {
                                return (
                                    <Col>
                                        <Button style={{ borderRadius: '15px', width: '100px', backgroundColor: 'black', color: 'white' }} onClick={e => set_click_button(item)}>{item}</Button>
                                    </Col>
                                )
                            } else {
                                return (
                                    <Col>
                                        <Button style={{ borderRadius: '15px', width: '100px' }} onClick={e => set_click_button(item)}>{item}</Button>
                                    </Col>
                                )
                            }
                        })}

                    </Row>
                </Col> */}
                <Col>
                    <DeleteOutlined
                        style={{
                            fontSize: '1.5rem',
                            cursor: 'pointer'
                        }}
                        onClick={e => openDelete()}
                    />
                </Col>
                {
                    category.map(map_item => <>
                        <Col span={24}>
                            <Row>
                                <Col style={{ backgroundColor: map_item.background_color, padding: '8px', fontWeight: 600, color: '#FFFFFF', borderRadius: '5px', width: '80px', textAlign: 'center' }}>{map_item.category_name}</Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[16, 16]}>
                                {data && data.map((item, i) => (<>
                                    <Col md={{ span: 8 }} sm={{ span: 24 }}>
                                        <Card
                                            bodyStyle={{ padding: '10px' }}
                                            bordered
                                        >
                                            <Row justify={'center'} style={{ position: 'relative' }}>
                                                <Col className='example' style={{ position: 'absolute', left: '95%', top: '-10%', zIndex: 99 }}>
                                                    <EditOutlined
                                                        className='example'
                                                        style={{
                                                            backgroundColor: '#F9D4E5',
                                                            fontSize: '1.2rem',
                                                            borderRadius: '50%',
                                                            padding: '8px'
                                                        }}
                                                        onClick={e => handleEdit(item)}
                                                    />
                                                </Col>
                                                <Col style={{ position: 'absolute', left: '-5%', top: '-5%' }}>
                                                    <Avatar style={{ zIndex: 99 }} icon={<UserOutlined />} />
                                                </Col>
                                                <Col onClick={e => handlePreview(item.file_url)} style={{ cursor: 'pointer' }}>
                                                    <Carousel_news_ticker file_url={item['file_url']} height={'250px'} width={'250px'} />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} align={'middle'} justify={'center'}>
                                                <Col span={24} style={{ color: '#888888', fontSize: '0.9em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center' }}>
                                                    {item.blog_title} - {item.file_client_name}
                                                </Col>

                                                <Col span={24} style={{ color: '#888888', fontSize: '0.9em', textAlign: 'left' }}>
                                                    上傳人：{item.upload_user_name}
                                                </Col>
                                                <Col span={24} style={{ color: '#888888', fontSize: '0.9em', textAlign: 'left' }}>
                                                    {item.upload_time}
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col >
                                </>))}
                            </Row>
                        </Col >
                    </>)
                }
            </Row >
        </>
    )
}
export default AdminMedia